<template>
  <div>
    <AccountBalanceTable
      class="account-balance__table"
      :items="pagedItems"
      :headers="headers"
      :filters="filters"
    >
      <!--   View for filtering modals   -->

      <template #filter.date>
        TODO
      </template>

      <template #filter.completer>
        <BaseRadioList
          v-model="completerFilter"
          all="Все"
          :options="completerList"
          @input="$set(filters, 'completer', { items: !$event ? [] : [{ data: ($event || {}).key }] })"
        />
      </template>

      <!--   Custom view for Row data   -->

      <template #item.date="{ item }">
        {{ new Date(item.date).toLocaleDateString() }}
      </template>

      <template #item.income="{ item }">
        <AccountBalanceChip
          v-if="item.income === 'from'"
          class="_orange"
          value="Мой доход"
        />

        <AccountBalanceChip
          v-else-if="item.income === 'to'"
          value="От парнтера"
        />

        <AccountBalanceChip
          v-else
          :value="item.income"
        />
      </template>

      <template #item.action="{ item }">
        <div class="account-balance__table-action-title">
          <template v-if="(item.action || {}).type === 'successfully-job'">
            <BaseSvg name="ico-check-outline" />
            <span class="mr-2">Успешное трудоустройство</span>

            <AccountBalanceTableUserItem
              :data="item.action.target"
              @click="() => null"
            />
          </template>

          <template v-else-if="(item.action || {}).type === 'bought-guarantee'">
            <BaseSvg name="ico-umbrella" />
            <span>Покупка страховки от партнера</span>
          </template>

          <template v-else-if="(item.action || {}).type === 'bought-ticket' && item.action.target">
            <BaseSvg name="ico-ticket" />
            <span class="mr-2">Покупка билета для</span>

            <AccountBalanceTableUserItem
              :data="item.action.target"
              @click="() => null"
            />
          </template>

          <template v-else-if="(item.action || {}).type === 'bought-ticket'">
            <BaseSvg name="ico-ticket" />
            <span>Покупка билета от партнера</span>
          </template>

          <template v-else-if="(item.action || {}).type === 'new-employee'">
            <BaseSvg name="ico-avatar-clear" />
            <span class="mr-2">Новый соискатель</span>

            <AccountBalanceTableUserItem
              :data="item.action.target"
              @click="() => null"
            />
          </template>

          <template v-else>- -</template>
        </div>
      </template>

      <template #item.completer="{ item }">
        <AccountBalanceChip
          v-if="item.completer === 'employee'"
          class="_green"
          value="Соискатель"
        />

        <AccountBalanceChip
          v-else-if="item.completer === 'partner'"
          class="_blue"
          value="Партнер"
        />

        <AccountBalanceChip
          v-else
          :value="item.completer"
        />
      </template>

      <template #item.partner="{ item }">
        <span v-if="!item.partner">- -</span>

        <AccountBalanceTableUserItem
          v-else
          :data="item.partner"
          @click="() => null"
        />
      </template>

      <template #item.summa="{ item }">
        <AccountBalanceChip
          class="_large _dark-blue"
          money
          :value="item.summa"
        />
      </template>
    </AccountBalanceTable>

    <div class="account-balance__footer">
      <div class="account-balance__footer-left">
      </div>

      <div class="account-balance__footer-right">
        <AccountBalanceCashRequestButton/>
      </div>
    </div>
  </div>
</template>

<script>
  import AccountBalanceTable from '@/components/balance/AccountBalanceTable';
  import AccountBalanceChip from '@/components/balance/AccountBalanceChip';
  import AccountBalanceTableUserItem from '@/components/balance/AccountBalanceTableUserItem';
  import AccountBalanceCashRequestButton from '@/components/balance/AccountBalanceCashRequestButton';

  export default {
    name: 'AccountBalanceIncoming',

    components: {
      AccountBalanceTable,
      AccountBalanceChip,
      AccountBalanceTableUserItem,
      AccountBalanceCashRequestButton
    },

    props: ['items'],

    data: () => ({
      page: 0,
      limit: 9,

      completerFilter: '',
      completerList: [
        { key: 'partner', text: 'Партнер' },
        { key: 'employee', text: 'Соискатель' }
      ],

      filters: {},
      headers: [
        { key: 'date', title: 'Дата', width: '9em' },
        { key: 'income', title: 'Доход', width: '12em' },
        { key: 'action', title: 'Операция', sortKey: 'type' },
        { key: 'completer', title: 'Операцию выполнил', width: '15em' },
        { key: 'partner', title: 'Партнер', sortKey: 'name' },
        { key: 'summa', title: 'Сумма', width: '15em', align: 'right' }
      ]
    }),

    computed: {
      pagedItems() {
        const start = this.page * this.limit;
        const end = (this.page + 1) * this.limit;
        return this.items.slice(start, end);
      }
    },

    methods: {
      toggleCompleterInFilter(data) {
        if (!this.filters.completer) this.$set(this.filters, 'completer', { items: [] });

        const userIndex = this.filters.completer.items.findIndex((filter) => filter.data === data);
        if (userIndex >= 0) this.filters.completer.items.splice(userIndex, 1);
        else this.filters.completer.items.push({ data });
      },

      // toggleUserInFilter(data) {
      //   if (!this.filters.partner) this.$set(this.filters, 'partner', { items: [] });
      //
      //   const userIndex = this.filters.partner.items.findIndex((filter) => (filter.data || {}).id === data.id);
      //   if (userIndex >= 0) this.filters.partner.items.splice(userIndex, 1);
      //   else this.filters.partner.items.push({ key: 'id', data });
      // }
    }
  };
</script>
